module.exports = __webpack_public_path__ + "images/taiyuMap.png?v=50998259";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/list/taiyuMap.png
 ** module id = 243
 ** module chunks = 3
 **/